import { useAuth } from './AuthContext';

const useFeatures = () => {
  const { sessionUserData } = useAuth();
  return sessionUserData?.user?.userRole?.features[0];
};

export default useFeatures;
